import { create } from "zustand";

export interface HotelInfo {
  hotelName: string | null;
  hotelCid: string | null;
}

interface HotelInfoState {
  hotelInfo: HotelInfo;
  setHotelInfo: (hotelName: string, hotelCid: string) => void;
}

export const useHotelInfoStore = create<HotelInfoState>((set) => ({
  hotelInfo: {
    hotelName: null,
    hotelCid: null,
  },
  setHotelInfo: (hotelName: string, hotelCid: string) =>
    set({ hotelInfo: { hotelName, hotelCid } }),
}));
